import { Stack, Typography, TableContainer} from '@mui/material'
import { useTranslation } from 'react-i18next'

import TableView, { useTable } from 'packages/ui/Table'

import COLUMNS_CONFIG_CONTACTS, { COLUMNS_CONFIG_DOCUMENTS } from './columns-config'
import { useProject } from '../../../use-projects'

export const TableDocuments = () => {
  const { loading, data } = useProject()
  const {t} = useTranslation()
  const documents = [...(data?.documents || [])].sort(
    (firstDocument, secondDocument) =>
      new Date(firstDocument.created_at).getTime() - new Date(secondDocument.created_at).getTime()
  )
  const apiTable = useTable({
    rowKey: 'id',
    items: documents,
    loading,
    columns: COLUMNS_CONFIG_DOCUMENTS
  })
  return (
    <Stack gap={2}>
      <Typography component={'span'} sx={{fontSize: 14, fontWeight: 600}}>{t('project.documents.title')}</Typography>
      <TableContainer>
        <TableView apiTable={apiTable} noItemsMessage={t('project.documents.no_content')}/>
      </TableContainer>
    </Stack>
  )
}
const TableContacts = () => {
  const { loading, data } = useProject()
  const {t} = useTranslation()
  const apiTable = useTable({
    rowKey: 'sf_id',
    items: data?.contacts || [],
    loading,
    columns: COLUMNS_CONFIG_CONTACTS,
  })
  return (
    <Stack gap={2}>
      <Typography component={'span'} sx={{fontSize: 14, fontWeight: 600}}>{t('project.contacts.title')}</Typography>
      <TableContainer>
        <TableView apiTable={apiTable} noItemsMessage={t('project.contacts.no_content')} />
      </TableContainer>
    </Stack>
  )
}

export default TableContacts